<template>
    <div class="block-in-page">
        <div class="block-header">
            <div class="block-header-left">
                <div class="my-balance">Вы проехали <span>{{ balance }} км</span></div>
                <div class="balance-info">
                    <p>1 км = <span class="score">1 балл </span> = 1 ₽</p>
                </div>
            </div>
            <div class="block-header-right">
                <div class="links">
                    <p>Регистрируйте чеки</p>
                    <a class="btn custom-btn" target="_blank" href="https://daccord.club/tasks/666">
                        На сайте
                    </a>
                    <a class="btn custom-btn btn-icon" target="_blank" href="https://t.me/daccord_club_bot">
                        <img :src="telegram" alt="Telegram icon" />
                    </a>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="main-left">
                <a class="card card1" target="_blank" href="https://daccord.club/tasks/666">
                    <p>Загружай чеки</br>и получай кешбэк</br><span class="cashback">7%</span></p>
                    <img :src="wallet" alt="wallet icon" />
                </a>
                <a class="card card2" target="_blank" href="https://daccord.club/tasks" >
                    <p class="card2-text">Выполняй новые <br /> задания - получай <br /> <span>до <strong>1000</strong> <br /> <b>баллов!</b></span></p>
                </a>
            </div>
        </div>
      
        <RoadAndCar :newBalance="balance"  />
       
        <footer class="footer">
            <div class="block-footer-right">
                <div class="links">
                    <p>Регистрируйте чеки</p>
                    <a class="btn custom-btn" target="_blank" href="https://daccord.club/tasks/666">
                        На сайте
                    </a>
                    <a class="btn custom-btn btn-icon" target="_blank" href="https://t.me/daccord_club_bot">
                        <img :src="telegram" alt="Telegram icon" />
                    </a>
                </div>
            </div>

            <div class="logo">
                <img :src="logo" alt="logo icon" />
            </div>
        </footer>
    </div>
</template>

<script>
    import telegram from '../../../assets/MyProgress/telegram.svg'
    import wallet from '../../../assets/MyProgress/wallet.svg'
    import factory from '../../../assets/MyProgress/factory.svg'
    import logo from '../../../assets/MyProgress/daccordLogo.png'
    import RoadAndCar from './RoadAndCar.vue'

    export default {
        name: "daccord-banner",

        props: ['balance'],

        components: {
            RoadAndCar,
        },
        
        data(){
            return {
                telegram,
                wallet,
                factory,
                logo,
            }
        },

        mounted(){
            if (document.body.offsetWidth <= 450) document.querySelector('.body-panel-content-page').style.padding = 0
        }
    }
</script>

<style scoped>
    .cashback{
        font-size: 30px;
    }
    a{
        text-decoration: none;
        color:#fff;
    }
    .block-in-page{
        border-radius: 40px;
        width: 100%;
        max-width: 1920px;
        height: 1040px;
        font-family: 'Montserrat', sans-serif;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
    }
    .block-header{
        display: flex;
        justify-content: space-between;
        margin: 29px 114px 32px 118px;
    }
    .block-header-left{
        display: flex;
        flex-direction: column;
    }
    .my-balance{
        font-weight: 600;
        font-size: 39px;
        color: #000;
    }
    .balance-info{
        font-weight: 600;
        font-size: 30px;
        color: #000;
    }
    .block-header-left span{
        font-weight: 700;
        font-size: 51px;
        color: #e6362c;
    }
    .block-header-right{
        font-weight: 600;
        font-size: 16px;
        color: #e6362c;
    }
    .links{
        display: flex;
        align-items:center;
        padding-top: 10px;
        gap: 11px;
    }
    .custom-btn{
        display: flex;
        align-items:center;
        padding: 15px 36px;
        border-radius:8px;
        height: 44px;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
        font-weight: 600;
        font-size: 16px;
        outline:none;
        display: flex;
        align-items:center;
        cursor: pointer;
        position: relative;
        
    }
    .custom-btn:hover {
        top: 2px;
    }
    .custom-btn:active {
        box-shadow: none;
        top: 4px;
    }
    .btn-icon{
        border-radius: 24px;
        padding: 9px;
        width: 48px;
        height: 48px;
    }
    .main{
        display: flex;
        flex: 1;
        justify-content: space-between;
        padding-left: 118px;
        padding-right: 90px; display: flex;
    }
    .main-left{
        display: flex;
        gap: 13px;
    }
    .card{
        width: 211px;
        height: 226px;
        border-radius: 17px;
        outline:none;
        border: none;
        display: block;
        position: relative;

        &:hover {
            transform: rotateX(--x-rotation) rotateY(--y-rotation) scale(1.1);
        }
    }
    .card:active {
        border: none;
        box-shadow: none;
        top: 4px;
    }
    .card1{
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
        background: #f6fafd;
        cursor: pointer;
    }
    .card1 p{
        margin-top: 24px;
        margin-left: 19px;
        font-weight: 600;
        font-size: 17px;
        color: #e6362c;
    }
    .card1 img{
        margin-left: 77px;
        position: relative;
        bottom: 15px;
    }
    .card2{
        padding-top: 25px;
        padding-left: 15px;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
        background: #e6362c url('../../../assets/MyProgress/road-banner.svg') no-repeat bottom;
        cursor: pointer;
    }
    .card2-text{
        font-weight: 600;
        font-size: 17.44px;
        color: #fff;
        line-height: 21.26px;

        span {
            font-size: 21.59px;
            font-weight: 600;
            line-height: 26.32px;
        }

        strong {
            font-size: 57.13px;
            font-weight: 900;
            line-height: 69.64px;
        }

        b {
            font-size: 26.93px;
            font-weight: 600;
            line-height: 32.82px;
            margin-left: 60px;
        }
    }
    .footer{
        display: flex;
        justify-content: end;
    }
    .logo{
        text-align: end;
        font-weight: 400;
        font-size: 11px;
        color: #2d2d2d;
    }
    .block-footer-right{
        font-weight: 600;
        font-size: 16px;
        color: #e6362c;
        display: none;
    }
    .score {
        font-size: 30px !important;
    }
@media (max-width: 1500px) {
    .block-header {
        margin: 29px 50px 32px 50px;
    }
    .main {
        padding-left: 50px;
        padding-right: 0;
    }
}

@media (max-width: 1400px) {
    .block-in-page {
        padding: 16px;
        height: 900px;
        width: 100%;
    }
    .block-header {
        display: block;
        margin: 0;
    }
    .main {
        padding-left: 0;
        padding-right: 0;
        max-height: 700px;
    }

    .links {
        p {
            font-size: 14px;
            width: 123px;
        }
        :nth-child(2) {
            flex-grow: 1;
            max-width: 144px;
        }
    }
    .card {
        width: 166px;
        height: 180px;
    }
    .card2{
        padding-top: 20px;
        padding-left: 12px;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
        background-size: 95%;
        background-position: left bottom;
        cursor: pointer;
    }
    .card2-text{
        font-size: 14px;
        color: #fff;
        line-height: 17px;

        span {
            font-size: 17px;
            line-height: 21px;
        }

        strong {
            font-size: 45.5px;
            font-weight: 900;
            line-height: 55.46px;
        }

        b {
            font-size: 21.45px;
            line-height: 26.14px;
            margin-left: 50px;
        }
    }
    .card1 p{
        font-size: 14px;
    }
    .card1 img{
        width: 96px;
        margin-left: 65px;
        bottom: 20px;
    }
    .main{
        margin-top: 20px;
    }
    .my-balance {
        font-size: 28px;
    }
    .block-header-left span {
        font-size: 28px;
    }
    .balance-info {
        font-size: 20px;
    }
    .main-left {
        gap: 10px;
    }
    .score {
        font-size: 30px !important;
    }
}

@media (max-width: 800px) {
    .block-header-right {
        display: none;
    }
    .block-in-page{
        height: 1000px;
        border-radius: 0;
    }
    .score {
        font-size: 20px !important;
    }
    .balance-info {
        display: flex;
        gap: 40px;
    }
    .footer {
        margin: 0;
        justify-content: flex-start;
        position: relative;
        bottom: -100px;

        .logo {
            display: none;
        }
    } 
    .block-footer-right{
        display: block;
        width: 100%;
    }  
}
</style>


// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/DaccordBanner.vue